module.exports = __webpack_public_path__ + "img/p15.201f2c4d.png";